import {useMemo} from 'react'
import {useDocumentData} from 'react-firebase-hooks/firestore'
import {db} from 'configs/firebase'
import get from 'lodash/get'

export default function useUserQuery(userId) {
  const docRef = userId ? db.doc(`users/${userId}`) : null
  const {error, loading, value} = useDocumentData(docRef)

  return useMemo(() => {
    if (value && (!value.permissions || !get(value, 'permissions.isEnabled'))) {
      return {error, loading, value: null}
    }

    return {error, loading, value}
  }, [value, error, loading])
}
